<template>

      <VueSlickCarousel v-bind="settings" ref="carousel" >
   <!--    <div>

  
    <img src="/img/photos/1.jpg"/>
      </div>
  
   <div>
    <img src="/img/photos/2.jpg"/>
      </div> --> 
      <div v-for="i in 104" :key= "i">
            
             <img :src="'/img/photos/'+i+'.jpg'">

  
          </div>
      <template #prevArrow="arrowOption">
      <div class="custom-arrow">
        {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
      </div>
    </template>
      <template #nextArrow="arrowOption">
      <div class="custom-arrow">
        {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
      </div>
    </template>
  

  </VueSlickCarousel>



</template>
<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'


  export default {
    name: 'myGallery',
    components: { VueSlickCarousel },
   
    
    data() {
      return {
        settings: {
            "arrows":true,
            "dots":false,
            "dotsClass": "slick-dots custom-dot-class",
            "lazyLoad": "ondemand",
            "focusOnSelect": true,
            "variableWidth": false,
            "adaptiveHeight": true,
            
           


            "edgeFriction": 0.35,
            "infinite": true,
            "speed": 500,
            "slidesToShow": 1,
            "slidesToScroll": 1
        },
      }
    },
  }
</script>
<style scoped>
/* .slideshow{
  height: 300px;
}
*/
img{
    width: 70%;
    height: 70%;
      margin: 0 160px;

}


@media screen and (max-width: 768px) {

.custom-arrow {display: none;}
img{ margin: 0px;
    width: 100%;
        height: 100%;
}


}


</style>